/* Design Your Dapo: a Dapo has two sides, so you pick a pattern for each and flip between them. */
(function () {
  'use strict';
  var root = document.getElementById('designer'); if (!root) return;
  var N = 1000, C = N / 2, mirror = true;
  var faces = [document.getElementById('cv0'), document.getElementById('cv1')];
  var presetsEl = document.getElementById('presets');
  var spin = document.getElementById('spin'), dflip = document.getElementById('dflip');
  var flipB = document.getElementById('flipb');
  var sideBtns = [document.getElementById('side0'), document.getElementById('side1')];
  var title = document.getElementById('pickTitle');
  var urls = JSON.parse(root.getAttribute('data-presets')), count = urls.length;
  var imgs = [null, null], chosen = [-1, -1], thumbs = [null, null], buttons = [];
  var side = 0, picked = [false, false];

  /* Dapo = two squares, one turned 45 degrees, giving an 8-point star */
  function squarePath(c, half, angle) {
    var a = angle, pts = [[-1, -1], [1, -1], [1, 1], [-1, 1]];
    c.beginPath();
    pts.forEach(function (p, i) {
      var x = p[0] * half, y = p[1] * half;
      var rx = x * Math.cos(a) - y * Math.sin(a), ry = x * Math.sin(a) + y * Math.cos(a);
      i ? c.lineTo(C + rx, C + ry) : c.moveTo(C + rx, C + ry);
    });
    c.closePath();
  }

  function pattern(c, img, turn, scale) {
    /* fills the whole canvas with the image, optionally mirrored into 4 quarters */
    var s = Math.min(img.width, img.height), sx = (img.width - s) / 2, sy = (img.height - s) / 2;
    var size = N * scale / 2;
    c.save();
    c.translate(C, C);
    c.rotate(turn);
    var reps = Math.ceil(C / size) + 1;
    for (var i = -reps; i < reps; i++) for (var j = -reps; j < reps; j++) {
      c.save();
      c.translate(i * size, j * size);
      if (mirror) c.scale((i % 2 ? -1 : 1), (j % 2 ? -1 : 1));
      var ox = (mirror && i % 2) ? -size : 0, oy = (mirror && j % 2) ? -size : 0;
      c.drawImage(img, sx, sy, s, s, ox, oy, size + 1, size + 1);
      c.restore();
    }
    c.restore();
  }

  function drawFace(cv, img) {
    if (!img) return;
    var ctx = cv.getContext('2d');
    var turn = 0, scale = 1.4;
    ctx.clearRect(0, 0, N, N);
    var outer = N * 0.34;               /* half-side of each square: points reach ~0.48N */
    ctx.save();
    var clip = new Path2D();
    [0, Math.PI / 4].forEach(function (a) {
      [[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(function (p, i) {
        var x = p[0] * outer, y = p[1] * outer;
        var px = C + x * Math.cos(a) - y * Math.sin(a), py = C + x * Math.sin(a) + y * Math.cos(a);
        i ? clip.lineTo(px, py) : clip.moveTo(px, py);
      });
      clip.closePath();
    });
    ctx.clip(clip, 'nonzero');
    pattern(ctx, img, turn, scale);
    /* depth: darken the outer square layer toward the edges, like a folded layer */
    var g = ctx.createRadialGradient(C, C, N * .12, C, C, N * .5);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,.22)');
    ctx.fillStyle = g; ctx.fillRect(0, 0, N, N);
    ctx.restore();

    /* the top layer: a smaller square turned 45 degrees */
    var inner = outer * 0.80;
    ctx.save();
    squarePath(ctx, inner, Math.PI / 4);
    ctx.shadowColor = 'rgba(0,0,0,.5)'; ctx.shadowBlur = 26; ctx.shadowOffsetY = 6;
    ctx.fillStyle = '#000'; ctx.fill();
    ctx.shadowColor = 'transparent';
    squarePath(ctx, inner, Math.PI / 4);
    ctx.clip();
    pattern(ctx, img, turn + Math.PI / 4, scale * 0.9);
    var g2 = ctx.createLinearGradient(0, 0, N, N);
    g2.addColorStop(0, 'rgba(255,255,255,.16)'); g2.addColorStop(.5, 'rgba(255,255,255,0)'); g2.addColorStop(1, 'rgba(0,0,0,.25)');
    ctx.fillStyle = g2; ctx.fillRect(0, 0, N, N);
    ctx.restore();

    /* stitched trim */
    ctx.save();
    ctx.lineJoin = 'round';
    ctx.strokeStyle = 'rgba(20,8,10,.7)'; ctx.lineWidth = 5;
    ctx.stroke(clip);
    ctx.setLineDash([10, 9]); ctx.strokeStyle = 'rgba(255,255,255,.6)'; ctx.lineWidth = 2;
    squarePath(ctx, inner, Math.PI / 4); ctx.stroke();
    ctx.restore();
  }


  function redraw() { drawFace(faces[0], imgs[0]); drawFace(faces[1], imgs[1]); }

  function showSide(s) {
    side = s;
    dflip.classList.toggle('flipped', s === 1);
    flipB.setAttribute('aria-pressed', s === 1);
    flipB.setAttribute('aria-label', s === 1 ? 'Show side 1' : 'Show side 2');
    sideBtns.forEach(function (b, i) { b.setAttribute('aria-pressed', i === s ? 'true' : 'false'); });
    title.textContent = 'Choose a pattern for side ' + (s + 1);
    buttons.forEach(function (b, i) { b.setAttribute('aria-pressed', i === chosen[s] ? 'true' : 'false'); });
  }

  function setSide(s, src, idx) {
    var im = new Image(); if (src.indexOf('blob:') !== 0) im.crossOrigin = 'anonymous';
    im.onload = function () {
      imgs[s] = im; chosen[s] = idx;
      if (thumbs[s]) thumbs[s].style.backgroundImage = 'url("' + src + '")';
      drawFace(faces[s], im);
      if (s === side) buttons.forEach(function (b, i) { b.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
    };
    im.src = src;
  }

  function choose(src, idx) {
    var s = side;
    setSide(s, src, idx);
    /* first time through: after side 1 is picked, move on to side 2 */
    if (s === 0 && !picked[0] && !picked[1]) { picked[0] = true; setTimeout(function () { showSide(1); }, 350); }
    else picked[s] = true;
  }

  for (var i = 1; i <= count; i++) (function (n) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dz-sw'; b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', 'Pattern ' + n);
    var t = new Image(); t.src = urls[n - 1]; t.alt = '';
    b.appendChild(t);
    b.addEventListener('click', function () { choose(urls[n - 1], n - 1); });
    presetsEl.appendChild(b); buttons.push(b);
  })(i);

  sideBtns.forEach(function (b, i) { thumbs[i] = b.querySelector('.dz-th'); b.addEventListener('click', function () { showSide(i); }); });
  flipB.addEventListener('click', function () { showSide(side ? 0 : 1); });

  var mirrorBtn = document.getElementById('mirror');
  mirrorBtn.addEventListener('click', function () {
    mirror = !mirror; mirrorBtn.setAttribute('aria-pressed', mirror); redraw();
  });
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setSpin(on) { spin.classList.toggle('paused', !on); }
  setSpin(!reduce);

  document.getElementById('rand').addEventListener('click', function () {
    var a = Math.floor(Math.random() * count), b = Math.floor(Math.random() * count);
    if (b === a) b = (a + 7) % count;
    setSide(0, urls[a], a); setSide(1, urls[b], b); picked = [true, true];
  });
  document.getElementById('save').addEventListener('click', function () {
    try {
      var o = document.createElement('canvas'); o.width = N * 2; o.height = N;
      var c = o.getContext('2d'); c.drawImage(faces[0], 0, 0); c.drawImage(faces[1], N, 0);
      o.toBlob(function (bl) {
        if (!bl) return;
        var a = document.createElement('a'); a.href = URL.createObjectURL(bl); a.download = 'my-dapo.png'; a.click();
      });
    } catch (e) {}
  });

  function label(s) { return chosen[s] >= 0 ? 'Pattern ' + (chosen[s] + 1) + ' of ' + count : 'My own image'; }
  var buy = document.getElementById('dz-buy'), form = document.getElementById('dz-form');
  if (buy && form) buy.addEventListener('click', function () {
    var txt = buy.innerHTML; buy.disabled = true; buy.textContent = 'Preparing your design...';
    var o = document.createElement('canvas'); o.width = N * 2; o.height = N;
    var c = o.getContext('2d');
    try { c.drawImage(faces[0], 0, 0); c.drawImage(faces[1], N, 0); } catch (e) {}
    o.toBlob(function (bl) {
      try {
        if (bl && window.DataTransfer) {
          var dt = new DataTransfer(); dt.items.add(new File([bl], 'my-dapo-design.png', { type: 'image/png' }));
          document.getElementById('p-file').files = dt.files;
        }
      } catch (e) {}
      document.getElementById('p-side1').value = label(0) + (mirror ? ', mirrored' : '');
      document.getElementById('p-side2').value = label(1) + (mirror ? ', mirrored' : '');
      form.requestSubmit ? form.requestSubmit() : form.submit();
      setTimeout(function () { buy.disabled = false; buy.innerHTML = txt; }, 1500);
    }, 'image/png');
  });

  showSide(0);
  setSide(0, urls[0], 0);
  setSide(1, urls[13], 13);
})();
